export const shouldRequestPhoneSyncStatus = (isOpen, chatId, messageProviderId) =>
  Boolean(isOpen && chatId && Number(messageProviderId) === 2);
